import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

const PodcasterImpersonateSection = ({ onImpersonate, impersonating }) => (
    <Row className="g-3">
        <Col md={12}><hr className="my-1" /></Col>
        <Col md={12} className="text-center">
            <p className="text-muted small mb-2">
                Generates a one-time magic link (valid for 60 seconds) that logs in as this podcaster. Copy it and paste into an incognito window.
            </p>
        </Col>
        <Col md={12} className="d-flex justify-content-center">
            <Button variant="outline-warning" onClick={onImpersonate} disabled={impersonating}>
                {impersonating ? <><Spinner size="sm" animation="border" className="me-2" />Generating…</> : 'Log in as Podcaster'}
            </Button>
        </Col>
    </Row>
);

export default PodcasterImpersonateSection;
